<template>
	<!-- <div class="lds-ring"><div></div><div></div><div></div><div></div></div> -->
	<div class="con-vs-loading vs-loading-background-undefined vs-loading-color-undefined">
		<div class="vs-loading border">
				<div class="effect-1 effects"></div>
				<div class="effect-2 effects"></div>
				<div class="effect-3 effects"></div>
				<img src="">
		</div>
	</div>

</template>

<style scoped>
.con-vs-loading {
    width: 100%;
    /* height: 100%; */
    left: 0;
    top: 0;
    /* background: hsla(0, 0%, 100%, .6); */
    z-index: 300000;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
}
.con-vs-loading .vs-loading {
    position: relative;
    width: 55px;
    height: 55px;
    display: block;
    border-radius: 50%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 3px solid transparent;
}
.con-vs-loading .vs-loading.corners .effect-1 {
    -webkit-animation: corners 1s ease infinite;
    animation: corners 1s ease infinite;
}
.con-vs-loading .vs-loading.corners .effect-1, .con-vs-loading .vs-loading.radius .effect-3 {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 3px solid #1f74ff;
    border-radius: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.con-vs-loading .vs-loading .effects {
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
}
.con-vs-loading .vs-loading .effects {
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
}
.con-vs-loading .vs-loading .effects {
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
}
.content:not(.custom) img {
    max-width: 100%;
}
.con-vs-loading .vs-loading .effects {
    -webkit-transition: all .3s ease;
    transition: all .3s ease;
}
.con-vs-loading .vs-loading.border .effect-1,.con-vs-loading .vs-loading.default .effect-1{
    -webkit-animation:rotate 1s ease infinite;
    animation:rotate 1s ease infinite
}
.con-vs-loading .vs-loading.border .effect-1,.con-vs-loading .vs-loading.border .effect-2,.con-vs-loading .vs-loading.default .effect-1,.con-vs-loading .vs-loading.default .effect-2{
    position:absolute;
    width:100%;
    height:100%;
    border:3px solid transparent;
    border-left:3px solid  #1f74ff;
    border-radius:50%;
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.con-vs-loading .vs-loading.border .effect-2,.con-vs-loading .vs-loading.default .effect-2{
    -webkit-animation:rotateOpacity 1s ease infinite .1s;
    animation:rotateOpacity 1s ease infinite .1s
}
.con-vs-loading .vs-loading.border .effect-3,.con-vs-loading .vs-loading.default .effect-3{
    position:absolute;
    width:100%;
    height:100%;
    border:3px solid transparent;
    border-left:3px solid  #1f74ff;
    -webkit-animation:rotateOpacity 1s ease infinite .2s;
    animation:rotateOpacity 1s ease infinite .2s;
    border-radius:50%;
    -webkit-box-sizing:border-box;
    box-sizing:border-box
}
.con-vs-loading .vs-loading.border{
    border:1px solid #f0f0f0
}
.con-vs-loading .vs-loading.border .effect-1,.con-vs-loading .vs-loading.border .effect-2,.con-vs-loading .vs-loading.border .effect-3{
    border:1px solid transparent;
    border-left:1px solid  #1f74ff;
}
@-webkit-keyframes rotate{
    0%{
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
    }
    to{
        -webkit-transform:rotate(1turn);
        transform:rotate(1turn)
    }
}
@keyframes rotate{
    0%{
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
    }
    to{
        -webkit-transform:rotate(1turn);
        transform:rotate(1turn)
    }
}
@-webkit-keyframes rotateOpacity{
    0%{
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg);
        opacity:.1
    }
    to{
        -webkit-transform:rotate(1turn);
        transform:rotate(1turn);
        opacity:1
    }
}
@keyframes rotateOpacity{
    0%{
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg);
        opacity:.1
    }
    to{
        -webkit-transform:rotate(1turn);
        transform:rotate(1turn);
        opacity:1
    }
}
@-webkit-keyframes scale{
    0%{
        -webkit-transform:scale(.1);
        transform:scale(.1)
    }
    60%{
        -webkit-transform:scale(1);
        transform:scale(1)
    }
    to{
        -webkit-transform:scale(.1);
        transform:scale(.1)
    }
}
@keyframes scale{
    0%{
        -webkit-transform:scale(.1);
        transform:scale(.1)
    }
    60%{
        -webkit-transform:scale(1);
        transform:scale(1)
    }
    to{
        -webkit-transform:scale(.1);
        transform:scale(.1)
    }
}
@-webkit-keyframes radius{
    0%{
        -webkit-transform:rotate(0deg) scale(.1);
        transform:rotate(0deg) scale(.1);
        opacity:1
    }
    60%{
        -webkit-transform:rotate(160deg) scale(1);
        transform:rotate(160deg) scale(1);
        opacity:0
    }
    to{
        -webkit-transform:rotate(0deg) scale(.1);
        transform:rotate(0deg) scale(.1);
        opacity:1
    }
}
@keyframes radius{
    0%{
        -webkit-transform:rotate(0deg) scale(.1);
        transform:rotate(0deg) scale(.1);
        opacity:1
    }
    60%{
        -webkit-transform:rotate(160deg) scale(1);
        transform:rotate(160deg) scale(1);
        opacity:0
    }
    to{
        -webkit-transform:rotate(0deg) scale(.1);
        transform:rotate(0deg) scale(.1);
        opacity:1
    }
}
@-webkit-keyframes corners{
    0%{
        border-radius:50%;
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
    }
    25%{
        border-radius:50% 50% 50% 20%
    }
    50%{
        border-radius:50% 50% 20% 30%
    }
    75%{
        border-radius:50% 20% 30% 30%
    }
    to{
        border-radius:50%;
        -webkit-transform:rotate(-180deg);
        transform:rotate(-180deg)
    }
}
@keyframes corners{
    0%{
        border-radius:50%;
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
    }
    25%{
        border-radius:50% 50% 50% 20%
    }
    50%{
        border-radius:50% 50% 20% 30%
    }
    75%{
        border-radius:50% 20% 30% 30%
    }
    to{
        border-radius:50%;
        -webkit-transform:rotate(-180deg);
        transform:rotate(-180deg)
    }
}
@-webkit-keyframes sound{
    0%{
        -webkit-transform:scaleY(0);
        transform:scaleY(0);
        opacity:.7
    }
    40%{
        -webkit-transform:scaleY(1.2);
        transform:scaleY(1.2);
        opacity:.5
    }
    70%{
        -webkit-transform:scaleY(.2);
        transform:scaleY(.2);
        opacity:.8
    }
    50%{
        -webkit-transform:scaleY(1);
        transform:scaleY(1);
        opacity:1
    }
}
@keyframes sound{
    0%{
        -webkit-transform:scaleY(0);
        transform:scaleY(0);
        opacity:.7
    }
    40%{
        -webkit-transform:scaleY(1.2);
        transform:scaleY(1.2);
        opacity:.5
    }
    70%{
        -webkit-transform:scaleY(.2);
        transform:scaleY(.2);
        opacity:.8
    }
    50%{
        -webkit-transform:scaleY(1);
        transform:scaleY(1);
        opacity:1
    }
}
@-webkit-keyframes dash{
    0%{
        stroke-dashoffset:187
    }
    50%{
        stroke-dashoffset:46.75;
        -webkit-transform:rotate(135deg);
        transform:rotate(135deg)
    }
    to{
        stroke-dashoffset:187;
        -webkit-transform:rotate(450deg);
        transform:rotate(450deg)
    }
}
@keyframes dash{
    0%{
        stroke-dashoffset:187
    }
    50%{
        stroke-dashoffset:46.75;
        -webkit-transform:rotate(135deg);
        transform:rotate(135deg)
    }
    to{
        stroke-dashoffset:187;
        -webkit-transform:rotate(450deg);
        transform:rotate(450deg)
    }
}
@-webkit-keyframes colors{
    0%{
        stroke:#4285f4
    }
    25%{
        stroke:#de3e35
    }
    50%{
        stroke:#f7c223
    }
    75%{
        stroke:#1b9a59
    }
    to{
        stroke:#4285f4
    }
}
@keyframes colors{
    0%{
        stroke:#4285f4
    }
    25%{
        stroke:#de3e35
    }
    50%{
        stroke:#f7c223
    }
    75%{
        stroke:#1b9a59
    }
    to{
        stroke:#4285f4
    }
}
@-webkit-keyframes rotator{
    0%{
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
    }
    to{
        -webkit-transform:rotate(270deg);
        transform:rotate(270deg)
    }
}
@keyframes rotator{
    0%{
        -webkit-transform:rotate(0deg);
        transform:rotate(0deg)
    }
    to{
        -webkit-transform:rotate(270deg);
        transform:rotate(270deg)
    }
}

</style>

<script>
export default {
  props: ['type'],
  computed: {
    setHeight: function () {
      if (this.type == 'modal') {
        return 'height: 200px'
      } else {
        return 'height: calc(100vh - 54px);'
      }
    }
  }
}
</script>
